import React from 'react';

import EventListItem from './EventListItem';
import ListFromApi from "../ListFromApi";

function EventsPage() {
    return (
        <ListFromApi url="/events"
            elementType={EventListItem}
            errorMessage="A rendezvények letöltése sikertelen."
        />
    );
}

export default EventsPage;